import { CommonModule } from '@angular/common';
import { Component, effect, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { US_STATES, USState, StateInfo } from 'voxr-shared';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-state-selector',
  standalone: true,
  imports: [
    CommonModule, FormsModule,
    MatCheckboxModule, MatTooltipModule, MatIconModule, MatButtonModule
  ],
  templateUrl: './state-selector.component.html'
})
export class StateSelectorComponent {
  stateList = US_STATES;

  states = model<USState[]>([]);
  required = input<boolean>(false);
  disabled = input<boolean>(false);

  value = '';

  filteredStates: StateInfo[] = [];

  constructor() {
    effect(() => {
      this.states();
      this.updateDisplayValue();
    });
  }

  async ngOnInit() {
    this.filterList(this.value);
  }

  private updateDisplayValue() {
    const states = this.states();
    if (states.length === 0) {
      this.value = '';
      return;
    }

    // Display the first selected state name or show count if multiple
    if (states.length === 1) {
      const stateInfo = this.stateList.find((s: StateInfo) => s.code === states[0]);
      this.value = stateInfo ? stateInfo.name : states[0];
    } else {
      this.value = `${states.length} states selected`;
    }
  }

  onInputChange(filter: string) {
    this.filterList(filter);
    // If the field is cleared, emit empty array
    if (!filter) {
      this.emitValue([]);
    }
  }

  onToggle(stateCode: string) {
    // Handle clear all option
    if (stateCode === '') {
      this.emitValue([]);
      return;
    }

    // Add the state code to existing selection if not already included
    const currentStates = this.states() || [];
    const isAlreadySelected = currentStates.includes(stateCode as USState);

    if (!isAlreadySelected) this.emitValue([...currentStates, stateCode as USState]);
    else this.emitValue(currentStates.filter(s => s !== stateCode));
  }

  private filterList(text: string) {
    const q = text.toLowerCase().trim();
    if (!q) {
      this.filteredStates = this.stateList;
      return;
    }

    this.filteredStates = this.stateList.filter((state: StateInfo) =>
      state.name.toLowerCase().includes(q) ||
      state.code.toLowerCase().includes(q)
    );
  }

  isStateSelected(stateCode: string): boolean {
    return this.states()?.includes(stateCode as USState) || false;
  }

  private emitValue(val: USState[]) {
    this.states.set(val);
    this.updateDisplayValue();
  }
}
